export enum DownloadExportType {
    LoadPlan = 'Load Plan',
    TransferSheet = 'Transfer Sheet',
    PickList = 'Pick List',
    PickListAmendment = 'Pick List Amendment',
}
